import axios from 'axios';
import React from 'react'
import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { NavLink } from 'react-router-dom'
import Siteinfo from '../Dashbord/Siteinfo/Siteinfo';
interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  Gallery: string;
  category: string;
  tags: string;
  author: string;
}

interface CategoryInter {
  id: number;
  slug: string;
  name: string;
}
interface HeaderStruc {
  social: string;
  emails: string;
  number: string;
  logo:string;
}
function chunkArray<T>(arr: T[], chunkCount: number): T[][] {
  const result: T[][] = [];
  const chunkSize = Math.ceil(arr.length / chunkCount);
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}
const Footer = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [tags, setTags] = useState<CategoryInter[]>([]);
     const [headerData, setHeaderData] = useState<HeaderStruc | null>(null);
     useEffect(() => {
    fetchTags();
    fetchHeader();
  }, []);

  const fetchTags = async () => {
    try {
      const res = await axios.get<CategoryInter[]>(`${api}/auth/category`);
      setTags(res.data);
    } catch (err) {
      console.error('Error fetching category:', err);
    }
  };
   const fetchHeader = async () => {
      try {
        const res = await axios.get<HeaderStruc>(`${api}/auth/siteinfo`);
        setHeaderData(res.data);
        console.log('res.data, ', res.data);
      } catch (err) {
        console.error('Error fetching site info:', err);
      }
    };
  

    const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const groupedTags = chunkArray(tags, 4);

  let socials: { icon: string; link: string }[] = [];
  if (headerData?.social) {
    try {
      socials = JSON.parse(headerData.social);
    } catch (e) {
      console.error('Invalid social JSON', e);
    }
  }

  return (
    <footer className='bg-black text-gray-300 px-6 md:px-20 py-10 overflow-x-hidden'>
     
       <h1 className='font-bold mb-3 text-gray-300 text-2xl'>NEWS SECTIONS</h1>
     
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6 mb-8 text-lg font-normal">
      {groupedTags.map((group, index) => (
        <div key={index}>
          {index === 0 ? (
            <h1 className="font-bold mb-6 text-gray-300 text-2xl"></h1>
          ) : (
            <h2 className="invisible">.</h2>
          )}
          {group.map((item) => (
            <a
              key={item.id}
              href={`/category/${item.slug}`}
              className="block hover:underline text-gray-300"
            >
              {item.name}
            </a>
          ))}
        </div>
      ))}
    </div>



       <hr className="border-gray-700 my-6" />

       <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-sm text-gray-300">

        <div>
            <h3 className='text-gray-300 font-bold mb-3 text-2xl'>ABOUT US</h3>
            <p className='text-lg text-gray-300'>First India is Rajasthan's own English Newspaper. We bring you the most exclusive news from the power corridors of Rajasthan along with the best of national, international and sports news from across the world.</p>
        </div>

        <div>
            <h3 className='text-gray-300 mb-3 font-bold text-2xl'>FOLLOW US</h3>
            <div className='flex space-x-4 mb-4'>
                {socials.map((items)=>(
                  <a href={items.link}><img src={`${api}/${items.icon}`} className="h-10 w-10 rounded-full p-1" alt={items.icon}/></a>
                ))}
             
          
            </div>
            <h3 className='text-gray-300 font-bold text-2xl mb-4'>DOWNLOAD APPS</h3>
            <div className='space-y-4'>
                <a href="#"><img src={`${api}/uploads/google_play.webp`} alt="Google Play" className='h-14 mb-5 border border-red-600 rounded-md'/></a>
                
            </div>
        </div>

        <div className='text-gray-300 font-bold mb-3'>
            <h3 className='text-gray-300 font-bold mb-3 text-2xl'>QUICK LINKS</h3>
            <nav className='flex flex-col space-y-2'>
                <NavLink to='/contact' className='hover:underline text-lg font-normal'>Contact</NavLink>
                <NavLink to='/privacy' className='hover:underline text-lg font-normal'>Privacy Policy</NavLink>
                <NavLink to='/paper' className='hover:underline text-lg font-normal'>E-Paper</NavLink>
                <NavLink to='/advertise' className='hover:underline text-lg font-normal'>Advertise With Us</NavLink>
            </nav>                         
        </div>

        <div>
            <h3 className='text-gray-300 font-bold mb-3 text-2xl'>#JCTWEET</h3>
            <div className='flex items-start space-x-4'>
               
                <p className='text-lg w-56'>True leadership is about creating a vision that others want to follow</p>
            </div>
            <div className='flex items-center mt-4'>
                
                <p>Dr. Jagdeesh Chandra <br /><span className='text-gray-400'>(CMD & Editor-in-Chief)</span></p>
            </div>
        </div>
       </div>

        <div className='bg-[#111] text-gray-300 w-full py-3 px-4 md:px-20 flex justify-between items-center text-lg mb-[-24px]'>
            <p>© 2025 FIRST EXPRESS PUBLISHERS. All rights reserved | IT Partner{" "}
                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-pink-400 hover:underline">
                      Atriq
                    </a>
            </p>
            {showScroll && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-5 right-5 bg-pink-700 hover:bg-pink-800 text-white p-3 rounded-full shadow-lg transition-all"
                    >
                    <FaArrowUp/>
                </button>
                )}
        </div>
    </footer>
  )
}

export default Footer
